import { identityService } from "./identityService_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { idem } from "../idem.mjs";
import { app } from "../app_v2.js";

/**
 * Returns and array of identities whose name contains the search string. If there are no identities found, it
 * returns status 200 with the identities array as empty.
 ** type "local" only searches the local brower cache
 ** type "firstLetter" only searches a partition containing accounts that start with that letter
 ** type "tableScan" searches all identities
 * @param {string} characters
 * @returns {{status:number, message: string, identities: [{identity}]}} Return object has three keys:
 * * status is a number that could be 200 or 400
 * * message is a string that an error message if the status is not 200.
 * * identities: [{identity}, {identity}]
 */
const searchIdentities = async ({ characters, type }) => {
  if (typeof characters === "undefined") {
    const message = "ERROR: The input charactersnis not defined.";
    return { status: 400, message };
  }
  if (typeof type === "undefined") {
    const message = "ERROR: The input type is not defined.";
    return { status: 400, message };
  }
  if (characters === null) {
    const message = "ERROR: The input characters is null.";
    return { status: 400, message };
  }
  if (type === null) {
    const message = "ERROR: The input type is null.";
    return { status: 400, message };
  }
  if (typeof characters != "string") {
    const message = "ERROR: The input characters is not a string.";
    return { status: 400, message };
  }
  if (typeof type != "string") {
    const message = "ERROR: The input type is not a string.";
    return { status: 400, message };
  }
  if (identityService.isSearchValid(characters).status != 200) {
    const message =
      "ERROR: name failed validation check: " +
      name +
      " Message: " +
      result.message;
    return { status: 400, error: message };
  }
  if (["beginsWith", "contains"].includes(type) === false) {
    const message = "ERROR: The value for type is not valid";
    return { status: 400, error: message };
  }

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    return {
      status: pAIdentityResponse.status,
      identities: [],
      message: "Session has expired",
    };
  }
  const pAIdentity = pAIdentityResponse.identity;

  let response;
  try {
    const resource = "/v1/identity";
    const body = {
      idempotencyKey: idem.generateKey("identity"),
      searchString: characters,
      baseCharString: convert2BaseChars(characters),
      action: type,
      userID: pAIdentity.userID,
    };

    response = await fetch(app.getAPI_URL() + resource, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        authorization:
          "Bearer " + utilsApp.base64UrlEncode(pAIdentity.identityToken),
      },
    });
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
  } catch (error) {
    console.error(error.message);
    var status2Return = 500;
    if (Object.keys(error).includes("status")) {
      status2Return = error.status;
    }
    if (Object.keys(error).includes("statusCode")) {
      status2Return = error.statusCode;
    }
    return {
      status: status2Return,
      identities: [],
      message: "Unable to search for identities",
    };
  }

  const bodyAsText = await response.text();
  const bodyAsJSON = JSON.parse(bodyAsText);
  const identityToken = bodyAsJSON.identityToken;
  const refreshToken = bodyAsJSON.refreshToken;
  await identityService.updatePlayingAsTokens({ identityToken, refreshToken });
  const identitiesReturned = bodyAsJSON.identities;
  if (identitiesReturned.length > 0) {
    identityService.addIdentities(identitiesReturned);
  }
  return {
    status: 200,
    identities: identitiesReturned,
    message: "",
  };
};

const convert2BaseChars = (characters) => {
  const charArray = characters.split("");
  const baseCharArray = [];
  for (const char of charArray) {
    baseCharArray.push(utilsApp.removeDiacritics(char));
  }
  return baseCharArray.join("");
};

const postSearch2API = async ({ characters, type, pAIdentity }) => {};

export const identitySearchService = { searchIdentities };
